var _rect, _mask, _g, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSubPlan = function SvgSubPlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 97,
    viewBox: "0 0 180 97",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 97,
    rx: 4,
    fill: "#031FEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 180,
    height: 97
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 97,
    rx: 4,
    fill: "#031FEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 82.5,
    r: 56.5,
    stroke: "#0CFACA",
    strokeOpacity: 0.9,
    strokeWidth: 14
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 31.9953C48.0088 34.4319 47.4594 36.8382 46.3941 39.0293C45.3288 41.2204 43.7758 43.1381 41.8544 44.6351C39.933 46.1322 37.6943 47.1688 35.3101 47.6654C32.9259 48.1619 30.4597 48.1052 28.1009 47.4996V29.6881L33.7615 36.4143C34.1465 36.8722 34.6628 37.2005 35.2405 37.3547C35.8182 37.509 36.4294 37.4817 36.9911 37.2767C37.5528 37.0716 38.0379 36.6987 38.3806 36.2084C38.7233 35.7182 38.907 35.1343 38.9068 34.5361V17.5758C41.6278 18.8761 43.9255 20.9201 45.5346 23.4717C47.1437 26.0233 47.9983 28.9783 47.9999 31.9953ZM30.2469 27.5786L35.9076 34.3049V16.4911C32.0631 15.515 27.9931 16.0046 24.4893 17.8646C20.9855 19.7246 18.2984 22.8221 16.9507 26.5545C15.6029 30.287 15.6909 34.3876 17.1974 38.0587C18.7039 41.7299 21.5214 44.7092 25.1017 46.4171V29.4569C25.1015 28.8586 25.2852 28.2748 25.6279 27.7845C25.9706 27.2943 26.4557 26.9213 27.0174 26.7163C27.5791 26.5112 28.1903 26.484 28.768 26.6382C29.3457 26.7925 29.862 27.1208 30.2469 27.5786Z",
    fill: "white",
    fillOpacity: 0.3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubPlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subPlan.1aa47c65.svg";
export { ForwardRef as ReactComponent };